import { useResource } from '@atlassian/jira-router';
import { featuresResource } from '@atlassian/jira-router-resources-service-project-features/src/services/index.tsx';
import type { FeaturesData } from '@atlassian/jira-router-resources-service-project-features/src/types.tsx';

const useServiceProjectFeatures = () => useResource<FeaturesData | null>(featuresResource);

export default useServiceProjectFeatures;
